<div (click)="clicked($event)" class="h-100 w-100">
<input type="file"
       data-cy="drop-zone"
       #fileInput
       (change)="fileChanged($event.target.files[0])"
/>
<ng-content></ng-content>
</div>
